import React, { useState, useContext, useEffect } from 'react';
import { Modal, Input, Button } from 'antd';
import { newUserJoined, authorize, getUserUnreadMessageTopic } from '../api';
import SocketClientContext from '../contexts/SocketClient';
import { useGlobalState } from '../state';
import { registerForPushNotifications } from '../push';


export const USER_NAME_STORAGE_KEY = 'userName';
export const USER_EMAIL_STORAGE_KEY = 'userEmail';

function UserNameModal() {
  const isNewUser = localStorage.getItem(USER_NAME_STORAGE_KEY) == null;
  const [isModalVisible, setModalVisible] = useState(isNewUser);
  const [userNameInputValue, setUserNameInputValue] = useState('');
  const [userEmailInputValue, setUserEmailInputValue] = useState('');
  const socketClient = useContext(SocketClientContext);
  const [, setUnreadCountByChannel] = useGlobalState('unreadCountByChannel');
  const [unAuthorized, setUnauthorized] = useState(false);


  const onUserNameSubmit = async () => {

    const response = await authorize(userNameInputValue,userEmailInputValue);
    const authorized = response.data;
    console.log("Authorizing " + userEmailInputValue + ": " + authorized);

    if(authorized) {
      localStorage.setItem(USER_NAME_STORAGE_KEY, userNameInputValue);
      localStorage.setItem(USER_EMAIL_STORAGE_KEY, userEmailInputValue);
      setModalVisible(false);
      setUnauthorized(false)
      socketClient.subscribe(getUserUnreadMessageTopic(), ({body}) => {
        const unread = JSON.parse(body)
        setUnreadCountByChannel(unread);
      });
      await newUserJoined();
      registerForPushNotifications();
    } else{
      setUnauthorized(true)
    }
  };

  useEffect(() => {

    if(!isNewUser) {

      const loadData = async () => {
        const userNameInputValue = localStorage.getItem(USER_NAME_STORAGE_KEY)
        const userEmailInputValue = localStorage.getItem(USER_EMAIL_STORAGE_KEY)
        localStorage.getItem(USER_EMAIL_STORAGE_KEY)
        console.log("Authorizing existing user: " + userEmailInputValue);
        const response = await authorize(userNameInputValue, userEmailInputValue);
        const authorized = response.data;
        if(!authorized){
          console.log("This user has no access" );
          setUnauthorized(true)
          setUserNameInputValue(userNameInputValue);
          setUserEmailInputValue(userEmailInputValue);
          setModalVisible(true)
        } else{
          setModalVisible(false)
          setUnauthorized(false)
        }
      };

      loadData();
    }
  },[isNewUser]);

  return (
    <Modal
      title="Enter your name and email"
      visible={isModalVisible}
      footer={
        [
          <Button
            key="OK"
            onClick={onUserNameSubmit}
            type="primary"
          >
            OK
        </Button>
        ]
      }
      closable={false}
    >

      {unAuthorized &&
      <p>You're unauthorized to this workspace. Please make sure you use the same email address as the one used for registration with your hackathon organizer </p>
      }
      <Input
        autoFocus
        placeholder="name"
        onChange={event => { setUserNameInputValue(event.target.value) }}
        onPressEnter={onUserNameSubmit} />
      <Input
        placeholder="email"
        onChange={event => { setUserEmailInputValue(event.target.value) }}
        onPressEnter={onUserNameSubmit} />
    </Modal>
  );
}

export default UserNameModal;
